import React, {PropsWithChildren, useContext} from "react";
import {ServerDataContext} from "./ServerDataContext";
import {Invoice} from "../models/invoice.model";

export const InvoiceContext = React.createContext({} as Invoice);

export const InvoiceProvider: React.FunctionComponent<PropsWithChildren> = ({children}) => {
    const data = useContext(ServerDataContext);

    return (
        <InvoiceContext.Provider value={data.invoice}>
            {children}
        </InvoiceContext.Provider>
    )
}